module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/person3-554f05dc879d9606909e8ae44adfa805.png";